const MULTIPLIER = {
    k: 1000,
    m: 1000000,
    b: 1000000000,
}

/**
 * Take expression and replace multipliers.
 * @param value
 * @returns {string}
 */

const prepareExpression = value => {
    let cleanValue = String(value).replace(/\s/g, '')

    Object.keys(MULTIPLIER).forEach(
        multiplierKey => (cleanValue = cleanValue.replaceAll(multiplierKey, `*${MULTIPLIER[multiplierKey]}`)),
    )

    return cleanValue
}

export {
    prepareExpression
}